
/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AcknowledgeProjectFreelancerItemRequest,
  CancelAmendmentRequest,
  CancelProjectRequest,
  ContractContextResource,
  InitiateProjectRenewalRequest,
  InitiateProjectRenewalResponse,
  ProjectActivityResource,
  ProjectBudgetResource,
  ProjectContractResource,
  ProjectDeliverableResource,
  ProjectInformationResource,
  ProjectPaymentNotificationsResource,
  ProjectRenewalInformationResponse,
  UpdateClockOffsetDateTimeRequest,
  UpdateContractRequest,
  UpdateProjectFreelancerExternalReferenceRequest,
  ValidateProjectRequest,
} from '../models';
import {
    AcknowledgeProjectFreelancerItemRequestFromJSON,
    AcknowledgeProjectFreelancerItemRequestToJSON,
    CancelAmendmentRequestFromJSON,
    CancelAmendmentRequestToJSON,
    CancelProjectRequestFromJSON,
    CancelProjectRequestToJSON,
    ContractContextResourceFromJSON,
    ContractContextResourceToJSON,
    InitiateProjectRenewalRequestFromJSON,
    InitiateProjectRenewalRequestToJSON,
    InitiateProjectRenewalResponseFromJSON,
    InitiateProjectRenewalResponseToJSON,
    ProjectActivityResourceFromJSON,
    ProjectActivityResourceToJSON,
    ProjectBudgetResourceFromJSON,
    ProjectBudgetResourceToJSON,
    ProjectContractResourceFromJSON,
    ProjectContractResourceToJSON,
    ProjectDeliverableResourceFromJSON,
    ProjectDeliverableResourceToJSON,
    ProjectInformationResourceFromJSON,
    ProjectInformationResourceToJSON,
    ProjectPaymentNotificationsResourceFromJSON,
    ProjectPaymentNotificationsResourceToJSON,
    ProjectRenewalInformationResponseFromJSON,
    ProjectRenewalInformationResponseToJSON,
    UpdateClockOffsetDateTimeRequestFromJSON,
    UpdateClockOffsetDateTimeRequestToJSON,
    UpdateContractRequestFromJSON,
    UpdateContractRequestToJSON,
    UpdateProjectFreelancerExternalReferenceRequestFromJSON,
    UpdateProjectFreelancerExternalReferenceRequestToJSON,
    ValidateProjectRequestFromJSON,
    ValidateProjectRequestToJSON,
} from '../models';

export interface AcknowledgeProjectFreelancerItemOperationRequest {
    projectId: string;
    acknowledgeProjectFreelancerItemRequest: AcknowledgeProjectFreelancerItemRequest;
}

export interface AmendContractRequest {
    projectId: string;
    updateContractRequest: UpdateContractRequest;
}

export interface CancelContractAmendmentRequest {
    projectId: string;
    amendmentId: string;
    cancelAmendmentRequest: CancelAmendmentRequest;
}

export interface CancelProjectOperationRequest {
    projectId: string;
    cancelProjectRequest?: CancelProjectRequest;
}

export interface FetchContractContextRequest {
    projectId: string;
}

export interface GetProjectActivityRequest {
    projectId: string;
}

export interface GetProjectBudgetRequest {
    projectId: string;
}

export interface GetProjectContractRequest {
    projectId: string;
}

export interface GetProjectDeliverablesRequest {
    projectId: string;
}

export interface GetProjectInformationRequest {
    projectId: string;
}

export interface GetProjectInformationByCorrelationRequest {
    correlationId: string;
}

export interface GetProjectPaymentNotificationsRequest {
    projectId: string;
}

export interface InitiateProjectRenewalOperationRequest {
    projectId: string;
    initiateProjectRenewalRequest?: InitiateProjectRenewalRequest;
}

export interface SearchProjectRenewalRequest {
    projectId?: string;
    renewalId?: string;
}

export interface UpdateClockOffsetDateTimeOperationRequest {
    projectId: string;
    updateClockOffsetDateTimeRequest: UpdateClockOffsetDateTimeRequest;
}

export interface UpdateProjectFreelancerExternalReferenceOperationRequest {
    projectId: string;
    updateProjectFreelancerExternalReferenceRequest: UpdateProjectFreelancerExternalReferenceRequest;
}

export interface ValidateProjectOperationRequest {
    projectId: string;
    validateProjectRequest?: ValidateProjectRequest;
}

/**
 * 
 */
export class ProjectFreelancerApi extends runtime.BaseAPI {

    /**
     * Set a project freelancer item as acknowledged
          */
    async acknowledgeProjectFreelancerItemRaw(requestParameters: AcknowledgeProjectFreelancerItemOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling acknowledgeProjectFreelancerItem().'
            );
        }

        if (requestParameters['acknowledgeProjectFreelancerItemRequest'] == null) {
            throw new runtime.RequiredError(
                'acknowledgeProjectFreelancerItemRequest',
                'Required parameter "acknowledgeProjectFreelancerItemRequest" was null or undefined when calling acknowledgeProjectFreelancerItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/project/{projectId}/acknowledge`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AcknowledgeProjectFreelancerItemRequestToJSON(requestParameters['acknowledgeProjectFreelancerItemRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Set a project freelancer item as acknowledged
          */
    async acknowledgeProjectFreelancerItem(requestParameters: AcknowledgeProjectFreelancerItemOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.acknowledgeProjectFreelancerItemRaw(requestParameters, initOverrides);
    }

    /**
     * Amend a project contract
          */
    async amendContractRaw(requestParameters: AmendContractRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling amendContract().'
            );
        }

        if (requestParameters['updateContractRequest'] == null) {
            throw new runtime.RequiredError(
                'updateContractRequest',
                'Required parameter "updateContractRequest" was null or undefined when calling amendContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/project/{projectId}/contract`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateContractRequestToJSON(requestParameters['updateContractRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Amend a project contract
          */
    async amendContract(requestParameters: AmendContractRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.amendContractRaw(requestParameters, initOverrides);
    }

    /**
     * Amend a project contract
          */
    async cancelContractAmendmentRaw(requestParameters: CancelContractAmendmentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling cancelContractAmendment().'
            );
        }

        if (requestParameters['amendmentId'] == null) {
            throw new runtime.RequiredError(
                'amendmentId',
                'Required parameter "amendmentId" was null or undefined when calling cancelContractAmendment().'
            );
        }

        if (requestParameters['cancelAmendmentRequest'] == null) {
            throw new runtime.RequiredError(
                'cancelAmendmentRequest',
                'Required parameter "cancelAmendmentRequest" was null or undefined when calling cancelContractAmendment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/project/{projectId}/contract/{amendmentId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))).replace(`{${"amendmentId"}}`, encodeURIComponent(String(requestParameters['amendmentId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: CancelAmendmentRequestToJSON(requestParameters['cancelAmendmentRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Amend a project contract
          */
    async cancelContractAmendment(requestParameters: CancelContractAmendmentRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelContractAmendmentRaw(requestParameters, initOverrides);
    }

    /**
     * Cancel a project
          */
    async cancelProjectRaw(requestParameters: CancelProjectOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling cancelProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/project/{projectId}/cancel`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelProjectRequestToJSON(requestParameters['cancelProjectRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Cancel a project
          */
    async cancelProject(requestParameters: CancelProjectOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelProjectRaw(requestParameters, initOverrides);
    }

    /**
     * Fetch a contract context
          */
    async fetchContractContextRaw(requestParameters: FetchContractContextRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContractContextResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling fetchContractContext().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContractContextResource>({
            path: `/project-freelancer/api/project/{projectId}/contract/context`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContractContextResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch a contract context
          */
    async fetchContractContext(requestParameters: FetchContractContextRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContractContextResource> {
        const response = await this.fetchContractContextRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve current action to be done by the freelancer and the history of past events
          */
    async getProjectActivityRaw(requestParameters: GetProjectActivityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectActivityResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectActivity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectActivityResource>({
            path: `/project-freelancer/api/project/{projectId}/activity`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectActivityResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve current action to be done by the freelancer and the history of past events
          */
    async getProjectActivity(requestParameters: GetProjectActivityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectActivityResource> {
        const response = await this.getProjectActivityRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve budget information of a project
          */
    async getProjectBudgetRaw(requestParameters: GetProjectBudgetRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectBudgetResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectBudget().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectBudgetResource>({
            path: `/project-freelancer/api/project/{projectId}/budget`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectBudgetResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve budget information of a project
          */
    async getProjectBudget(requestParameters: GetProjectBudgetRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectBudgetResource> {
        const response = await this.getProjectBudgetRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve project contract for the freelancer to amend it
          */
    async getProjectContractRaw(requestParameters: GetProjectContractRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectContractResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectContract().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectContractResource>({
            path: `/project-freelancer/api/project/{projectId}/contract`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectContractResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve project contract for the freelancer to amend it
          */
    async getProjectContract(requestParameters: GetProjectContractRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectContractResource> {
        const response = await this.getProjectContractRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve deliverables information of a project
          */
    async getProjectDeliverablesRaw(requestParameters: GetProjectDeliverablesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<ProjectDeliverableResource>>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectDeliverables().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<ProjectDeliverableResource>>({
            path: `/project-freelancer/api/project/{projectId}/deliverables`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(ProjectDeliverableResourceFromJSON);
        return response;
    }

    /**
     * Retrieve deliverables information of a project
          */
    async getProjectDeliverables(requestParameters: GetProjectDeliverablesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<ProjectDeliverableResource>> {
        const response = await this.getProjectDeliverablesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get information about a project
          */
    async getProjectInformationRaw(requestParameters: GetProjectInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectInformationResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectInformation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectInformationResource>({
            path: `/project-freelancer/api/project/{projectId}`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectInformationResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get information about a project
          */
    async getProjectInformation(requestParameters: GetProjectInformationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectInformationResource> {
        const response = await this.getProjectInformationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Fetch the project information by correlation id
          */
    async getProjectInformationByCorrelationRaw(requestParameters: GetProjectInformationByCorrelationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectInformationResource>> {
        if (requestParameters['correlationId'] == null) {
            throw new runtime.RequiredError(
                'correlationId',
                'Required parameter "correlationId" was null or undefined when calling getProjectInformationByCorrelation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['correlationId'] != null) {
            queryParameters['correlationId'] = requestParameters['correlationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectInformationResource>({
            path: `/project-freelancer/api/project`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectInformationResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch the project information by correlation id
          */
    async getProjectInformationByCorrelation(requestParameters: GetProjectInformationByCorrelationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectInformationResource> {
        const response = await this.getProjectInformationByCorrelationRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Retrieve payment notification state per deliverable (badge and dot on the Payment tab)
          */
    async getProjectPaymentNotificationsRaw(requestParameters: GetProjectPaymentNotificationsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectPaymentNotificationsResource>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling getProjectPaymentNotifications().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectPaymentNotificationsResource>({
            path: `/project-freelancer/api/project/{projectId}/payment-notifications`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectPaymentNotificationsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Retrieve payment notification state per deliverable (badge and dot on the Payment tab)
          */
    async getProjectPaymentNotifications(requestParameters: GetProjectPaymentNotificationsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectPaymentNotificationsResource> {
        const response = await this.getProjectPaymentNotificationsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Initiate a renewal of a project
          */
    async initiateProjectRenewalRaw(requestParameters: InitiateProjectRenewalOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<InitiateProjectRenewalResponse>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling initiateProjectRenewal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<InitiateProjectRenewalResponse>({
            path: `/project-freelancer/api/project/{projectId}/renewal/initiate`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InitiateProjectRenewalRequestToJSON(requestParameters['initiateProjectRenewalRequest']),
        }, initOverrides);

        if (response._data) { response._data=InitiateProjectRenewalResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Initiate a renewal of a project
          */
    async initiateProjectRenewal(requestParameters: InitiateProjectRenewalOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<InitiateProjectRenewalResponse> {
        const response = await this.initiateProjectRenewalRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get information about a project renewal
          */
    async searchProjectRenewalRaw(requestParameters: SearchProjectRenewalRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ProjectRenewalInformationResponse>> {
        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        if (requestParameters['renewalId'] != null) {
            queryParameters['renewalId'] = requestParameters['renewalId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ProjectRenewalInformationResponse>({
            path: `/project-freelancer/api/project/renewal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ProjectRenewalInformationResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get information about a project renewal
          */
    async searchProjectRenewal(requestParameters: SearchProjectRenewalRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ProjectRenewalInformationResponse> {
        const response = await this.searchProjectRenewalRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update the project Clock date time machine
          */
    async updateClockOffsetDateTimeRaw(requestParameters: UpdateClockOffsetDateTimeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateClockOffsetDateTime().'
            );
        }

        if (requestParameters['updateClockOffsetDateTimeRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClockOffsetDateTimeRequest',
                'Required parameter "updateClockOffsetDateTimeRequest" was null or undefined when calling updateClockOffsetDateTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/project/{projectId}/clock`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClockOffsetDateTimeRequestToJSON(requestParameters['updateClockOffsetDateTimeRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the project Clock date time machine
          */
    async updateClockOffsetDateTime(requestParameters: UpdateClockOffsetDateTimeOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateClockOffsetDateTimeRaw(requestParameters, initOverrides);
    }

    /**
     * Update the freelancer external reference
          */
    async updateProjectFreelancerExternalReferenceRaw(requestParameters: UpdateProjectFreelancerExternalReferenceOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling updateProjectFreelancerExternalReference().'
            );
        }

        if (requestParameters['updateProjectFreelancerExternalReferenceRequest'] == null) {
            throw new runtime.RequiredError(
                'updateProjectFreelancerExternalReferenceRequest',
                'Required parameter "updateProjectFreelancerExternalReferenceRequest" was null or undefined when calling updateProjectFreelancerExternalReference().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/project/{projectId}/freelancerExternalReference`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProjectFreelancerExternalReferenceRequestToJSON(requestParameters['updateProjectFreelancerExternalReferenceRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the freelancer external reference
          */
    async updateProjectFreelancerExternalReference(requestParameters: UpdateProjectFreelancerExternalReferenceOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateProjectFreelancerExternalReferenceRaw(requestParameters, initOverrides);
    }

    /**
     * Validate the end of a project
          */
    async validateProjectRaw(requestParameters: ValidateProjectOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling validateProject().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/project/{projectId}/validate`.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ValidateProjectRequestToJSON(requestParameters['validateProjectRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Validate the end of a project
          */
    async validateProject(requestParameters: ValidateProjectOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.validateProjectRaw(requestParameters, initOverrides);
    }

}
